import { defineComponent as _defineComponent } from 'vue'
import { FifQuestion } from "./questions";
import FIFSurvey from "./FIFSurvey.vue";
import FIFOpenCalendar from "./Buttons/OpenCalendar.vue";
import FIFSetAnAppointment from "./Buttons/SetAnAppointment.vue";
import { FifScript } from "@/views/NewBusiness/FIF/FIFSurvey/FifScripts";
import { computed, ref, watch } from "vue";

type ScriptConfig = {
	scriptType: FifScript;
	successMessage: string;
	failMessage: string;
	button?: "OPEN_CALENDAR" | "SET_AN_APPOINTMENT";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FIFSurveyForm',
  props: {
	questions: {
		type: Object as () => Record<FifScript, FifQuestion[]>,
		required: true,
	},
	scripts: {
		type: Object as () => Record<FifScript, boolean>,
		required: false,
	},
  	tryAgain: Boolean,
},
  emits: ["scriptFinished"],
  setup(__props, { expose, emit }: { emit: ({
	(e: "scriptFinished", value: FifScript): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const currentScriptIndex = ref(0);
const surveyResult = ref<null | {
	message: string;
	button?: "OPEN_CALENDAR" | "SET_AN_APPOINTMENT";
	fifScript: FifScript;
}>(null);

const reset = () => {
	currentScriptIndex.value = 0;
	surveyResult.value = null;
};

expose({ reset })

const scriptsOrdered = computed<FifScript[]>(() => {
	const result = [];
	if (!props.scripts || props.scripts[FifScript.DFL]) {
		result.push(FifScript.DFL);
	}
	if (!props.scripts || props.scripts[FifScript.QRS]) {
		result.push(FifScript.QRS);
	}
	if (!props.scripts || props.scripts[FifScript.IUL]) {
		result.push(FifScript.IUL);
	}
	if (!props.scripts || props.scripts[FifScript.IBC]) {
		result.push(FifScript.IBC);
	}
	if (!props.scripts || props.scripts[FifScript.Annuity]) {
		result.push(FifScript.Annuity);
	}
	return result;
});

const currentScript = computed(() => {
	return scriptsOrdered.value[currentScriptIndex.value];
});
const currentScriptQuestions = computed(() => {
	return props.questions[currentScript.value];
});
const cardTitle = computed(() => {
	return {
		[FifScript.DFL]: "Debt Free Life",
		[FifScript.QRS]: "Quility Retirement Services",
		[FifScript.IUL]: "Indexed Universal Life",
		[FifScript.IBC]: "Infinite Banking Concept",
		[FifScript.Annuity]: "Annuity Reset",
	}[currentScript.value];
});

const isLastScript = (script: FifScript): boolean => {
	return (
		scriptsOrdered.value.indexOf(script) === scriptsOrdered.value.length - 1
	);
};

const processScript = (
	answers: any[],
	{ scriptType, successMessage, failMessage, button }: ScriptConfig
): boolean => {
	if (currentScript.value !== scriptType) { return false }

	const isComplete = answers.some((a) => a.answer === true);
	if (isComplete) {
		surveyResult.value = {
			message: successMessage,
			button,
			fifScript: scriptType,
		};
		emit("scriptFinished", currentScript.value);
		return true;
	}

	if (!isLastScript(scriptType)) {
		currentScriptIndex.value += 1;
		return true;
	}

	surveyResult.value = {
		message: failMessage,
		fifScript: scriptType,
	};
	return true;
};

const scriptsConfig: Record<FifScript, ScriptConfig> = {
	[FifScript.DFL]: {
		scriptType: FifScript.DFL,
		successMessage: `
                        We have an entire division solely based on education around debt elimination and our Debt Free Life program, they are SUBJECT MATTER EXPERTS. They can give you the education, and you can do whatever you want with that information, but I KNOW you are going to be happy with what you hear. They have helped so many of my clients.

                        Let's look at their calendar and see when they are available to meet…
                        `,
		failMessage: `Thank you for your time. Please let me know if anything changes and we can review your position.`,
		button: "OPEN_CALENDAR",
	},
	[FifScript.QRS]: {
		scriptType: FifScript.QRS,
		successMessage: `
                        We have an entire division solely based on education around retirement. Quility Financial Advisors are SUBJECT MATTER EXPERTS and they can educate you on your retirement accounts and help you fill in any gaps you might have. You can do whatever you want with that information, but I KNOW you are going to be happy with the information. They have helped out so many of my clients.

                        Let’s look at their calendar and see when they are available to meet…
                        `,
		failMessage: `At this time mortgage protection is the best solution for your client. We will review the file in a year for the PCS program`,
		button: "SET_AN_APPOINTMENT",
	},
	[FifScript.IUL]: {
		scriptType: FifScript.IUL,
		successMessage: `
                        We have an entire division solely based around risk free retirement. Our Subject Matter Experts can educate you on our risk-free retirement program. You can do whatever you want with that information, but i KNOW you are going to be happy with the results as they have helped so many of my clients in the past.

                        Let's take a look at their calendar and see when they are available…
                        `,
		failMessage: `Thank you for your time. Please let me know if anything changes and we can review your position.`,
		button: "OPEN_CALENDAR",
	},
	[FifScript.Annuity]: {
		scriptType: FifScript.Annuity,
		successMessage: ``,
		failMessage: `Thank you for your time. Please let me know if anything changes and we can review your position.`,
		button: "OPEN_CALENDAR",
	},
	[FifScript.IBC]: {
		scriptType: FifScript.IBC,
		successMessage: ``,
		failMessage: ``,
	},
}

const onFinish = (answers: any[]): void => {
	// See: https://quility.atlassian.net/jira/software/projects/DEVST/boards/12?selectedIssue=DEVST-1695
	const currentScriptConfig = scriptsConfig[currentScript.value]
	processScript(answers, currentScriptConfig)
};

watch(() => props.scripts, () => {
	reset();
});

return { __sfc: true,props, emit, currentScriptIndex, surveyResult, reset, scriptsOrdered, currentScript, currentScriptQuestions, cardTitle, isLastScript, processScript, scriptsConfig, onFinish, FIFSurvey, FIFOpenCalendar, FIFSetAnAppointment, FifScript }
}

})